import script from "./PublicInfoPageLayout.vue?vue&type=script&setup=true&lang=js"
export * from "./PublicInfoPageLayout.vue?vue&type=script&setup=true&lang=js"

import "./PublicInfoPageLayout.vue?vue&type=style&index=0&id=4138a99c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4138a99c"]])

export default __exports__